import React, { useEffect, useState } from 'react'
import { Button, DatePicker, Input, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import useParams from '../../hook/useParams'
import { DownloadOutlined } from '@ant-design/icons'
import MainTable from '../../components/Basic/MainTable'
import { fetchIndicatorPreview } from '../../apis/indicator'
import dayjs from 'dayjs'

function IndicatorDetails (props) {
  const { modalData, form, setModalData } = props
  const { t: ln_t } = useTranslation()
  const params = useParams({ sort: 'date' })
  const { fetchParams, handleFetchParams } = params
  const { data } = modalData
  const [columns, setColumns] = useState([])
  const [dimensionOpt, setDimensionOpt] = useState([])

  const apiFunc = async () => {
    const payload = {
      ...fetchParams,
      ...fetchParams?.sort ? { order: fetchParams?.sort?.includes('-') ? 'DESC' : 'ASC' } : {},
      startIndex: (fetchParams?.startIndex / 10) + 1
    }
    return await fetchIndicatorPreview(data?.id, payload).then(res => {
      if (res?.status !== 200) return res
      const { totalCount, dimensions, columns, values } = res?.data || {}
      setDimensionOpt(dimensions?.map(i => ({ value: i.id, label: i.name })))
      if (!fetchParams?.dimensionId && fetchParams?.dimensionId !== 0) handleFetchParams('add', { dimensionId: dimensions?.[0]?.id })
      setColumns(columns?.map(i => ({ title: i.name, dataIndex: i.header, sorter: i.header === 'date' })))
      const data = values?.map((i, idx) => ({ generatedId: idx, ...i }))
      return { status: res?.status, data, headers: { ...res?.header, 'x-content-record-total': totalCount } }
    })
  }

  const handleDownload = () => setModalData({ open: true, type: 'download', data, disableDate: true, setting: fetchParams })

  const handleChangeDate = date => {
    const [start, end] = date || []
    const startDate = start && dayjs(start).format('YYYY-MM-DD')
    const endDate = end && dayjs(end).format('YYYY-MM-DD')
    handleFetchParams('add', { startDate, endDate, startIndex: 0 })
  }

  useEffect(() => {
    if (!modalData?.open) return
    form.setFieldValue('name', modalData?.download?.name || ln_t('indicator.allIndicators'))
  }, [modalData?.open])

  return <>
    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '16px 0' }}>
      {fetchParams?.dimensionId ? <Input.Search style={{ width: '180px' }} placeholder={ln_t('util.search')} onSearch={e => handleFetchParams('add', { search: e, startIndex: 0 })} /> : ''}
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <div>{ln_t('indicator.dimension')} :</div>
        <Select
          options={dimensionOpt}
          value={fetchParams?.dimensionId}
          onChange={e => handleFetchParams('add', { dimensionId: e, startIndex: 0 })}
          style={{ minWidth: '80px' }}
        />
      </div>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <div>{ln_t('indicator.timeInterval')} :</div>
        <DatePicker.RangePicker onChange={handleChangeDate} />
      </div>
      <Button icon={<DownloadOutlined />} onClick={handleDownload}>{ln_t('util.download')}</Button>
    </div>

    <MainTable
      columns={columns}
      rowKey="generatedId"
      apiFunc={apiFunc}
      params={params}
    />
  </>
}

export default IndicatorDetails
